import type {ProLayoutProps} from '@ant-design/pro-components';

/**
 * @name AdsConsole 系统默认配置
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  "navTheme": "light",
  "colorPrimary": "#1677FF",
  "layout": "mix",
  "contentWidth": "Fluid",
  "fixedHeader": true,
  "fixSiderbar": true,
  "pwa": false,
  "logo": "/logo.svg",
  "splitMenus": false,
  "token": {},
  "siderMenuType": "sub"
}

export default Settings;
